import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div<{ isEmpty?: boolean }>`
  padding: ${({ theme }) => theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: ${({ theme, isEmpty }) => (isEmpty ? theme.space["space-4"] : 0)};
  }
`;

export const Header = styled.div`
  padding-bottom: ${({ theme }) => theme.space["space-4"]};
  display: grid;
  grid-template-columns: 1fr 145px 48px;
  align-items: center;
`;

export const PPWrapper = styled.div`
  @media screen and ${breakpoints.tablet.min.sm} {
    padding-top: 2px;
    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.colors.blue_accent[100]};
    }
  }
`;
